export default __webpack_public_path__ + "static/media/paper.14a6128f.svg";